import parse from "html-react-parser";
import { CTabPane } from "@coreui/react";
import "@coreui/coreui/dist/css/coreui.min.css";
import { ContentInfo } from "./TicketRefundInfo.styles";

const TicketRefundInfoContent = ({
  activeKey,
  ticket: {
    product: { cancelInfo },
  },
}) => {
  if (activeKey === 1) {
    return (
      <CTabPane role="tabpanel" visible={activeKey === 1}>
        <ContentInfo style={{ lineHeight: "1.5" }}>
          {cancelInfo && parse(cancelInfo)}
        </ContentInfo>
      </CTabPane>
    );
  }
};

export default TicketRefundInfoContent;
